
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 2.25a4.132 4.132 0 00-4.125 4.125A4.132 4.132 0 0012 10.5a4.132 4.132 0 004.125-4.125A4.132 4.132 0 0012 2.25zM1.875 10.5a3 3 0 116 0 3 3 0 11-6 0zm1.5 0c0 .825.675 1.5 1.5 1.5s1.5-.675 1.5-1.5S5.7 9 4.875 9s-1.5.675-1.5 1.5zm7.508.75a2.257 2.257 0 00-2.25 2.25 2.257 2.257 0 002.25 2.25 2.257 2.257 0 002.25-2.25 2.257 2.257 0 00-2.25-2.25zm-.75 2.25c0 .412.337.75.75.75.412 0 .75-.338.75-.75a.752.752 0 00-.75-.75.752.752 0 00-.75.75zm-.758-7.125A2.628 2.628 0 0012 9a2.628 2.628 0 002.625-2.625A2.628 2.628 0 0012 3.75a2.628 2.628 0 00-2.625 2.625z","fill":"#585858"}})])
          )
        }
      }
    